import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modeGamma';
const args = {};

export class ModeGamma extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
